import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform, ToastController, Alert, Toast, Events } from 'ionic-angular';

/*
  Generated class for the ToastAlertsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ToastAlertsProvider {
  private alertBox: Alert;
  private toastBox: Toast;
  constructor(public http: HttpClient, private alerter: AlertController, private toast: ToastController, private platform : Platform, private events : Events) {

  }
  public showGenericConfirm(message){
    let resolveQuestion;
    const decision = new Promise<number>(resolve => resolveQuestion = resolve);
    const alert = this.alerter.create({
      title: "<i class='fa fa-exclamation-triangle alertTriangle' ></i>",
      subTitle: message,
      buttons: [
        {
          text: 'Yes',
          handler: () => resolveQuestion(1)
        },
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => resolveQuestion(0)
        }
      ],
      cssClass: 'custom-large-alert'
    })
    this.events.subscribe('timeoutCalled', ()=> {
      if(alert) alert.dismiss().catch(err=>{});
      resolveQuestion(-1);
    });
    alert.present();
    alert.onDidDismiss(()=>{
      this.events.unsubscribe('timeoutCalled');
    })
    return decision;
  }
  showAlert(title, message, alertType?, timeout?:number) {
    return new Promise( async (resolve, reject) => {
    if (alertType && alertType === 'success') {
      this.alertBox = this.alerter.create({
        title: "<i class='fa fa-check successSymbol' ></i>",
        subTitle: message,
        buttons: ['OK'],
        cssClass: 'custom-large-alert'
      });
    } else if (alertType && alertType === 'warning'){
      this.alertBox = this.alerter.create({
        title: "<i class='fa fa-exclamation-triangle alertTriangle' ></i>",
        subTitle: message,
        buttons: ['OK'],
        cssClass: 'custom-large-alert'
      });
    } else if (alertType && alertType === 'danger'){
      this.alertBox = this.alerter.create({
        title: "<i class='fa fa-exclamation-triangle dangerSymbol' ></i>",
        subTitle: message,
        buttons: ['OK'],
        cssClass: 'custom-large-alert',
      });
    }else{
      this.alertBox = this.alerter.create({
        title: "<i class='fa fa-exclamation-triangle alertTriangle' ></i>",
        subTitle: message,
        buttons: ['OK'],
        cssClass: 'custom-large-alert'
      });
    }

    this.alertBox.present();
    if (timeout > 0){
      setTimeout(()=>this.alertBox.dismiss().then(()=>resolve()).catch(err=>reject()), timeout);
    }
  });
  }
  dismiss(){
    // console.log('dismiss called');
    if(this.platform.is('cordova')){
      if(this.alertBox)this.alertBox.dismiss().catch(err=>{});
    }else{
      if(this.toastBox)this.toastBox.dismiss().catch(err=>{});
    }
  }
  triggerToast(msg, messageTitle, alertType?, timeout?:number) {
    if(!this.platform.is('cordova')){
      this.showAlert(messageTitle, msg, alertType, timeout);
      return;
    } else if (this.platform.is('cordova')) {
      this.toastBox = this.toast.create({
        message: msg,
        duration: timeout || 2000
      });
      this.toastBox.present();
    }
  }

  onlyToast(msg){
    this.toastBox = this.toast.create({
      message: msg,
      duration: 2000
    });
    this.toastBox.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/toast-alerts/toast-alerts.ts